import request from '@aned/request';

// 查询装载率详情
export async function search_day(params) {
  return request('/api/route/loadingRatio/search_day', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 查询合计
export async function aggregate(params) {
  return request('/api/route/loadingRatio/search_day/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

/**
 *
 */

export async function search_week(params) {
  return request('/api/route/loadingRatio/search_week', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function weekAggregate(params) {
  return request('/api/route/loadingRatio/search_week/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function weekExport(params) {
  return request('/api/route/loadingRatio/search_week/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function search_month(params) {
  return request('/api/route/loadingRatio/search_month', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function monthAggregate(params) {
  return request('/api/route/loadingRatio/search_month/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function monthExport(params) {
  return request('/api/route/loadingRatio/search_month/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 实时装载率
export async function realTime(params) {
  return request('/api/route/loadingRatio/real_time', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 中转频次
export async function getTransitFrequency(params) {
  return request('/api/transfers/selectTransitFrequencyInfoList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 环节延误判定列表接口
export async function getDelayPage(params) {
  return request('/api/imputation/getPageNew', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast',
  });
}

//环节延误判定导出接口
export async function delayExport(params) {
  return request('/api/imputation/getPageNew/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

// 环节延误判定导出接口
// export async function delayExport(params) {
//   return request('/api/imputation/export', {
//     method: 'POST',
//     body: params,
//     reqType: 'json',
//     module: 'forecast',

//   });
// }

export async function search_day_export(params) {
  return request('/api/route/loadingRatio/search_day/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}